export default __webpack_public_path__ + "static/media/pin.2050ec11.svg";